module.exports = __webpack_public_path__ + "assets/6a35023f5e429b99a3ed0c9922900374.svg";